import React from 'react';
import s from './TradeFinance.module.css';
import p2p_money from '../../assets/img/p2p_money.png';
import p2p_money_mobile from '../../assets/img/mobile/p2p_money_mobile.png';
import tradeDesc from '../../assets/img/tradeFinanceImg1.png';
import tradeDesc2 from '../../assets/img/tradeFinanceImg3.png';
import tradeDesc3 from '../../assets/img/tradeFinanceImg4.png';
import { motion } from 'framer-motion';
import checkBox from '../../assets/img/check_circle_blue.svg';
import Hero from '../../components/hero/Hero';
import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet-async";

const TradeFinance = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>

      <Helmet>
        <title>Trade Finance Solutions for Global Trade | Wall Street IBU</title>
        <meta
            name="description"
            content="Comprehensive trade finance solutions for importers and exporters. Reduce risk, improve cash flow,
            and support international trade with Wall Street IBU."
        />
        <meta name="keywords" content="trade finance services,  trade finance solutions, bank for international trade"/>
      </Helmet>

      <motion.div
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className={s.motion_div}>
        <div className={s.content}>
          <Hero
            title_1={t('tradeFinance.hero.title_1')}
            title_2={t('tradeFinance.hero.title_2')}
            description={t('tradeFinance.hero.description')}
          />

          <div className={s.trade_desc}>
            <div className={s.trade_desc_left}>
              <img className={s.desc_image} src={tradeDesc} alt={t('tradeFinance.trade_desc.imageAlt1', 'Trade Description')} />
            </div>
            <div className={s.trade_desc_right}>
              <p className={s.trade_desc_paragraph}>
                {t('tradeFinance.trade_desc.paragraph1')}
              </p>
              <p className={s.trade_desc_paragraph}>
                {t('tradeFinance.trade_desc.paragraph2')}
              </p>
            </div>
          </div>
        </div>

        <div className={s.content}>
          <div className={s.instrumnet_wrapper}>
            <div className={s.instrumnet_overlay}>
              <div className={s.instrumnet_content}>
                <h3>
                  {t('tradeFinance.instrument_header')}
                  <br />
                  {t('tradeFinance.instrument_subheader')}
                </h3>

                <ul className={s.instrumnet_bullet_points}>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.instrument.bullet1')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.instrument.bullet2')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.instrument.bullet3')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.instrument.bullet4')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.instrument.bullet5')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.instrument.bullet6')}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className={s.content}>
          <div className={s.trade_desc}>
            <div className={s.trade_desc_left}>
              <p className={s.trade_desc_paragraph}>
                {t('tradeFinance.secondBlock.paragraph1')}
              </p>
              <p className={s.trade_desc_paragraph}>
                {t('tradeFinance.secondBlock.paragraph2')}
              </p>
            </div>
            <div className={s.trade_desc_right}>
              <img className={s.desc_image} src={tradeDesc2} alt={t('tradeFinance.trade_desc.imageAlt2', 'Trade Description 2')} />
            </div>
          </div>
        </div>

        <div className={s.content}>
          <div className={s.cards_wrapper}>
            <h3>
              {t('tradeFinance.cards_header')}
            </h3>
            <div className={s.trade_desc}>
              <div className={s.trade_desc_left}>
                <div className={s.card_01}>
                  <div className={s.card_number}>01.</div>
                  <div className={s.card_title}>
                    {t('tradeFinance.card1.title')}
                  </div>
                  <div className={s.card_text}>
                    {t('tradeFinance.card1.text')}
                  </div>
                </div>
              </div>
              <div className={s.trade_desc_right}>
                <div className={s.card_02}>
                  <div className={s.card_number}>02.</div>
                  <div className={s.card_title}>
                    {t('tradeFinance.card2.title')}
                  </div>
                  <div className={s.card_text}>
                    {t('tradeFinance.card2.text')}
                  </div>
                </div>
              </div>
            </div>
            <div className={s.card_03}>
              <div>
                <div className={s.card_number}>03.</div>
                <div className={s.card_title}>
                  {t('tradeFinance.card3.title')}
                </div>
                <div className={s.card_text}>
                  {t('tradeFinance.card3.text')}
                </div>
              </div>
              <div className={s.coins_img_block}>
                <img className={s.p2p_money} src={p2p_money} alt="" />
                <img className={s.p2p_money_mobile} src={p2p_money_mobile} alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className={s.content}>
          <div className={s.trade_desc}>
            <div className={s.trade_desc_left}>
              <img className={s.desc_image} src={tradeDesc3} alt={t('tradeFinance.trade_desc.imageAlt3', 'Trade Description 3')} />
            </div>
            <div className={s.trade_desc_right}>
              <p className={s.trade_desc_paragraph}>
                {t('tradeFinance.thirdBlock.paragraph1')}
              </p>
              <p className={s.trade_desc_paragraph}>
                {t('tradeFinance.thirdBlock.paragraph2')}
              </p>
            </div>
          </div>
        </div>

        <div className={s.content}>
          <div className={s.factor_wrapper}>
            <div className={s.factor_overlay}>
              <div className={s.factor_content}>
                <h3>
                  {t('tradeFinance.factor.header')}
                  <br />
                  {t('tradeFinance.factor.subheader')}
                </h3>

                <ul className={s.factor_bullet_points}>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.factor.bullet1')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.factor.bullet2')}</div>
                  </li>
                </ul>
                <ul className={s.factor_bullet_points2}>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.factor.bullet3')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.factor.bullet4')}</div>
                  </li>
                  <li>
                    <div><img src={checkBox} alt="" /></div>
                    <div>{t('tradeFinance.factor.bullet5')}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className={s.color_background}>
          <div>
            <div className={s.who_we_desc_block}>
              <div className={s.who_we_description}>
                <div>
                  <span className={s.white_bold}>{t('tradeFinance.whoWe.boldText')}</span> {t('tradeFinance.whoWe.paragraph1')}
                </div>
                <div>
                  {t('tradeFinance.whoWe.paragraph2')}
                </div>
                <div>
                  {t('tradeFinance.whoWe.paragraph3')}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={s.content}>
          <div className={s.gradient}>
            <div className={s.gradient_title}>
              {t('tradeFinance.gradient.title')}
            </div>
            <div className={s.flex}>
              <div className={s.left}>
                <div className={s.line}>
                  <div className={s.check_circle_blue}></div>
                  <div className={s.gradient_text}>{t('tradeFinance.gradient.left.line1')}</div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle_blue}></div>
                  <div className={s.gradient_text}>{t('tradeFinance.gradient.left.line2')}</div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle_blue}></div>
                  <div className={s.gradient_text}>{t('tradeFinance.gradient.left.line3')}</div>
                </div>
              </div>
              <div className={s.right}>
                <div className={s.line}>
                  <div className={s.check_circle_blue}></div>
                  <div className={s.gradient_text}>{t('tradeFinance.gradient.right.line1')}</div>
                </div>
                <div className={s.line}>
                  <div className={s.check_circle_blue}></div>
                  <div className={s.gradient_text}>{t('tradeFinance.gradient.right.line2')}</div>
                </div>
              </div>
            </div>
            <div className={s.gradient_footer}>
              <span className={s.bold}>{t('tradeFinance.gradient.footer.bold')}</span> {t('tradeFinance.gradient.footer.text')}
              <span className={s.bold_italic}>{t('tradeFinance.gradient.footer.highlight')}</span>
              {t('tradeFinance.gradient.footer.rest')}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default TradeFinance;
